import locationZoneComponent from './location_zone.component';
import locationZoneCreate from './create';
import locationZoneEdit from './edit';
import locationZoneAll from './all';

let locationZoneModule = angular.module('locationZone', [
    locationZoneCreate,
    locationZoneEdit,
    locationZoneAll
])

    .component('locationZone', locationZoneComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $stateProvider
            .state('location_zone.edit', {
                url: '/edit/:id',
                component: 'locationZoneEdit',
                data: {
                    requireACL: 'tnt_control_location_zone.edit'
                }
            })

            .state('location_zone.create', {
                url: '/create',
                component: 'locationZoneCreate',
                data: {
                    requireACL: 'tnt_control_location_zone.create'
                }
            })

            .state('location_zone.all', {
                url: '/all/:page',
                component: 'locationZoneAll',
                data: {
                    requireACL: 'tnt_control_location_zone.view'
                }
            })
    })
    .name;

export default locationZoneModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/location_zone/index.js